var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.key,staticClass:"process-button",on:{"click":_vm.onClick}},[_vm._t("default",null,{processParams:_vm.innerParams})],2)}
var staticRenderFns = []

export { render, staticRenderFns }